import { convertHexToRgbA } from '../utils';

const COLOR_SCHEME = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	LIGHT: 'light',
	DARK: 'dark',
	NEUTRAL: 'neutral',
	GHOST: 'ghost'
};

export const COLOR_SCHEME_STATES = {
	[COLOR_SCHEME.PRIMARY]: {
		normal: {
			backgroundColor: '#F8FF13'
		},
		hover: {
			backgroundColor: '#DEE500'
		},
		active: {
			backgroundColor: '#DEE500'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.LIGHT]: {
		normal: {
			backgroundColor: '#ffffff'
		},
		hover: {
			backgroundColor: '#EDEDE9'
		},
		active: {
			backgroundColor: '#D9D9D9'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.DARK]: {
		normal: {
			backgroundColor: '#181818'
		},
		hover: {
			backgroundColor: '#1D1D1E'
		},
		active: {
			backgroundColor: '#3B3934'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.NEUTRAL]: {
		normal: {
			backgroundColor: 'transparent'
		},
		hover: {
			backgroundColor: 'transparent'
		},
		active: {
			backgroundColor: 'transparent'
		},
		disabled: {
			backgroundColor: 'transparent'
		}
	},
	[COLOR_SCHEME.GHOST]: {
		normal: {
			backgroundColor: 'transparent'
		},
		hover: {
			backgroundColor: 'transparent'
		},
		active: {
			backgroundColor: 'transparent'
		},
		disabled: {
			backgroundColor: 'transparent'
		}
	}
};
